module.exports = __webpack_public_path__ + "img/PlanLatourSecurity.7a670605.jpg";